import '../scss/style.scss';

import navigation from './scripts/navigation';
import accordions from './scripts/accordions';
import tabs from './scripts/tabs';
import backgroundVideo from './scripts/background-video';
import splideBrands from './scripts/splide-brands';
import linkedCard from './scripts/linked-card';
// import searchFilters from './scripts/search-filters'; // INCOMPLETE
import searchForms from './scripts/search-forms';
import splideTrends from './scripts/splide-trends';

import '../../node_modules/@splidejs/splide/dist/css/splide-core.min.css';


if(document.readyState !== 'loading') {
	runOnStart();
}
else {
	document.addEventListener('DOMContentLoaded', function () {
			runOnStart()
	});
}

function runOnStart() {
	// Run your code here
	navigation();
	accordions();
	tabs();
	backgroundVideo();
	splideBrands();
	linkedCard();
	// searchFilters();
	searchForms();
	splideTrends();
}